import * as React from "react";
import { Button, Intent } from "./externals";
export class ApplyNSaveButtons extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const className = this.props.className !== undefined ? this.props.className : "";
        return (React.createElement("div", { className: className, style: {
                display: "flex",
                justifyContent: "space-between",
            } },
            React.createElement(Button, { style: { marginLeft: "inherit" }, text: "Cancel", onClick: this.props.cancelConfig.onAccept, name: "cancel", icon: "cross", disabled: this.props.cancelConfig.disabled, intent: Intent.DANGER, minimal: true, "data-testid": "cancelButton" }),
            React.createElement(Button, { style: { marginLeft: "auto" }, text: "Apply", onClick: this.props.applyConfig.onAccept, name: "apply", icon: "filter-keep", disabled: this.props.applyConfig.disabled, intent: Intent.NONE, minimal: true, "data-testid": "applyButton" }),
            React.createElement(Button, { text: "Save", onClick: this.props.saveConfig.onAccept, name: "save", icon: "floppy-disk", disabled: this.props.saveConfig.disabled, intent: Intent.SUCCESS, minimal: true, "data-testid": "saveButton" })));
    }
}
//# sourceMappingURL=ApplyNSaveButtons.js.map